<template>
  <div class="apply_container">
    <div class="navbar">
      <span> {{ type == 0 ? '场馆预约' : '场地预定' }}</span>
      <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
    </div>
    <div class="apply_content">
      <div class="header">
        <div class="name" v-if="type == 0">{{ detailInfo.venueName }}</div>
        <div class="name" v-if="type == 1">{{ detailInfo.siteName }}</div>
        <div class="address">
          <img src="@/assets/images/detail/performance/location.png" alt="" class="address-icon" />
          <div class="address-text">
            <span class="detail">地址：{{ detailInfo.address }}</span>
            <span class="shuline">|</span>
            <span>{{ detailInfo.distance | setMorKm }}km</span>
          </div>
          <img src="@/assets/images/detail/performance/navigation.png" @click="UNInavigation" alt="" class="arrow-icon" />
        </div>
        <div class="buildName" v-if="type == 1">所属场馆：{{ detailInfo.venueName }}</div>
      </div>
      <div class="section">
        <div class="header" style="border: 0">
          <div class="title"><span>*</span> 预约时间</div>

          <div class="more" @click="showCalendar = true">
            <img class="riliIcon" src="@/assets/images/detail/rili.png" alt="" />
            <div class="more-text">更多</div>
          </div>
        </div>
        <div class="reservation-choose-day-box">
          <div class="reservation-choose-day-list">
            <!-- :class="item.isReservationFull ? 'is_fill' : selectId == item.id ? 'selected' : ''" -->
            <div
              class="day-item"
              v-for="item in showDateList"
              @click="selectDate(item)"
              :class="item.isExpire || item.status != 1 ? 'is_fill' : item.isReservationFull ? 'is_fill' : selectId == item.id ? 'selected' : ''"
            >
              <div class="tag" v-if="item.isExpire">过期</div>
              <div class="tag" v-else-if="item.isReservationFull">约满</div>
              <img class="selected-icon" src="@/assets/images/detail/selected-icon.png" alt="" v-if="selectId == item.id && !item.isReservationFull" />
              <div class="name">{{ handledateName(item.rdate) }}</div>
              <div class="subname">{{ item.rdate.substring(5, 7) }}月{{ item.rdate.substring(8) }}日</div>
            </div>
          </div>
        </div>
        <div class="hour_content d-f fxw-w jc-sb">
          <div
            class="reservation-choose-time d-f fxd-c ai-c jc-c"
            v-for="(item, index) in hourList"
            @click="selectHour(item, index)"
            :class="item.isExpire ? 'is_fill' : item.isReservationFull ? 'is_fill' : hourId[index] == item.id ? 'selected' : ''"
          >
            <img class="selected-icon" src="@/assets/images/detail/selected-icon.png" alt="" v-if="hourId[index] == item.id && !item.isReservationFull && !item.isExpire" />
            <span style="margin-bottom: 2px">{{ item.startTime }}-{{ item.endTime }}</span>
            <div v-if="item.isExpire">已过期</div>
            <div v-else-if="item.isReservationFull">已约满</div>
            <div v-else>
              剩余名额: <span class="num">{{ item.remainNumber }}</span>
            </div>

            <!-- <img class="arrow-icon" src="@/assets/images/detail/down-arrow.png" alt="" /> -->
          </div>
        </div>
      </div>
      <div class="section" v-if="!empty">
        <div class="header" style="border: 0">
          <div class="title">
            <span class="star">*</span> <span>预约人</span>
            <span class="select_pepple" v-if="contactList.length > 0">已选择{{ selectPeopleId.length }}/{{ rules.maxPerson }}人</span>
          </div>
          <div class="addbtn d-f ai-c" :class="contactList.length >= 10 ? 'disable' : ''" @click="addUser">
            <img class="add-icon" src="@/assets/images/detail/performance/add.png" alt="" />
            <span>添加</span>
          </div>
        </div>
        <div class="selected-content">
          <div v-for="(item, index) in contactList">
            <div class="people d-f ai-c jc-sb">
              <div class="d-f ai-c">
                <div @click="selectContact(item, index)">
                  <img src="@/assets/images/detail/performance/checked.png" alt="" class="select_icon select" v-if="checkedId[index]" />
                  <div class="no_select" v-else></div>
                </div>
                <div>
                  <div class="name d-f ai-c">
                    <span>{{ item.name | encryptName }}</span>
                    <span class="tag" v-if="item.self">本人</span>
                  </div>
                  <div class="phone">{{ handleDecryptPhone(item.phone) }}</div>
                  <div class="identity_card">{{ handleDecryptCard(item.cardNumber) }}</div>
                </div>
              </div>
              <div class="d-f ai-c icon_right" v-if="!item.self">
                <div class="d-f fxd-c ai-c icon_item" @click="editContact(item, index)">
                  <img src="@/assets/images/detail/performance/edit.png" alt="" class="select_icon" />
                  <span>编辑</span>
                </div>
                <div class="d-f fxd-c ai-c" @click="delContact(item)">
                  <img src="@/assets/images/detail/performance/delete.png" alt="" class="select_icon" />
                  <span>删除</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="emtpy d-f fxd-c ai-c jc-c" v-if="empty">
        <img src="../../assets/images/detail/emtpy.png" alt="" class="empty_img" />
        <div class="title">暂无可预约时段</div>
      </div>
      <div class="tips d-f ai-c" v-if="rules.knowContent">
        <!-- <div class="yuanChoose"></div> -->
        <van-checkbox v-model="checked" icon-size="14px" checked-color="#A97048"></van-checkbox>
        <div class="rule" @click="goRule">我已阅读并同意<span class="green">《预约须知》</span></div>
      </div>
      <div class="confirm" @click="submitForm">提交预约</div>

      <van-popup v-model="addShow" round position="bottom" class="popup" :style="{ height: bottomMarginWhenFocus }">
        <div class="title">添加成员</div>
        <img src="@/assets/images/detail/performance/close.png" alt="" class="close_icon" @click="addShow = false" />
        <div class="form">
          <van-form ref="form">
            <van-field v-model="form.name" label="姓名" :rules="[{ required: true, message: '请填写姓名' }]" />
            <van-field readonly clickable name="picker" v-model="value1" label="证件类型" @click="showPicker = true" :rules="[{ required: true, message: '请选择证件类型' }]">
              <template slot="right-icon">
                <van-icon name="arrow-down" />
              </template>
            </van-field>
            <van-field v-model="form.cardNumber" label="证件号" :rules="credentialsRules" @focus="specialFocus" @blur="specialBlur" />
            <van-field v-model="form.phone" label="手机号" :rules="phoneRules" @focus="specialFocus" @blur="specialBlur" />
            <div class="summit_button" @click="onSubmit">
              <div class="btn">确认</div>
            </div>
          </van-form>
        </div>
      </van-popup>

      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false">
          <template #option="option">
            <div>{{ option.name }}</div></template
          >
        </van-picker>
      </van-popup>

      <van-dialog
        style="width: 260px"
        v-model="dialogShow"
        title=""
        show-cancel-button
        confirmButtonText="同意"
        confirmButtonColor="#A97048"
        cancelButtonText="不同意"
        @confirm="dialogConfirm"
        @cancel="dialogCancel"
      >
        <div class="content_dialog">为更好地保护你的合法权益请阅读并同意<span class="rules" @click="goRule">《预约须知》</span></div>
      </van-dialog>

      <van-dialog v-model="orderResultShow" title="" :show-confirm-button="false" :close-on-click-overlay="true">
        <div class="result_content d-f jc-c ai-c fxd-c">
          <img src="../../assets/images/detail/emtpy.png" alt="" class="result_img" />
          <div class="title">预约失败</div>
          <!-- <div>当前时段剩余名额不足，请重新选择</div> -->
          <div>{{ orderErrorMsg }}</div>
        </div>
      </van-dialog>

      <van-calendar title="预约日期" color="#A97048" style="height: 70%" :formatter="calendarFormatter" :max-date="maxDate" @confirm="confirmCalendar" v-model="showCalendar" />

      <van-popup :round="true" v-model="showAuthentication">
        <div class="authentication_box d-f fxd-c ai-c jc-c">
          <img src="../../assets/images/detail/img_name.png" alt="" class="img_name" />
          <div class="box_title">实名认证</div>
          <div class="sub_title">获取你的实名信息将用于为你实现快捷报名、预约等操作</div>
          <div class="name_btn box_btn" @click="handleAuthentication">立即实名</div>
          <div class="cancle_btn box_btn" @click="showAuthentication = false">取消</div>
        </div></van-popup
      >
    </div>
  </div>
</template>
<script>
import { getUserInfo } from '@/api/activity'
import { getKnowContent, getReservationDate, getReservationHour, getUserList, updateUser, removeUser, saveUser, saveVenueReservation } from '@/api/venue'
// import { getDictByCode } from '@/api/common'
import { encrypt, decrypt } from '@/utils/sm4'

export default {
  data() {
    return {
      id: '',
      type: '',
      detailInfo: {},
      //所有日期
      dateList: [],
      //展示的所有可预约日期
      showDateList: [],
      hourList: [],
      selectId: '',
      hourId: [],
      contactList: [],
      checkedId: [],
      value1: '身份证',
      form: {},
      message: '',
      showPicker: false,
      addShow: false,
      checked: false,
      dialogShow: false,
      orderResultShow: false,
      showAuthentication: false,
      empty: false,
      weekArrayList: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      rules: {},
      selectPeopleId: [],
      // 0-身份证，1-护照，2-港澳通行证，3-台胞证
      columns: [
        {
          name: '身份证',
          type: 0,
        },
        {
          name: '护照',
          type: 1,
        },
        {
          name: '港澳通行证',
          type: 2,
        },
        {
          name: '台胞证',
          type: 3,
        },
      ],
      credentialsRules: [
        { required: true, message: '请填写证件号' },
        {
          validator: (value) => {
            return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)
          },
          message: '身份证号有误',
        },
      ],
      phoneRules: [
        { required: true, message: '请填写手机号' },
        {
          validator: (value) => {
            return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)
          },
          message: '手机号有误',
        },
      ],
      bottomMarginWhenFocus: '60%',
      showCalendar: false,
      maxDate: new Date('2025-12-01'),
      orderErrorMsg: '',
    }
  },
  methods: {
    UNInavigation() {
      this.$myUni.postMessage({
        data: {
          methodsName: 'UNInavigation',
          data: {
            name: this.detailInfo.address,
            latitude: this.detailInfo.latitude,
            longitude: this.detailInfo.longitude,
          },
        },
      })
    },
    handleAuthentication() {
      this.$myUni.navigateTo({
        url: '/pages/login/authentication',
      })
    },
    submitForm() {
      // 判断是否实名
      getUserInfo().then((res) => {
        if (res.result.authenticationFlag == 0) {
          this.showAuthentication = true
        } else {
          this.apply()
        }
      })
    },
    apply() {
      let data = { dateId: '', venueId: '', hourIdList: [], contactUserIdList: [] }
      data.dateId = this.selectId
      // data.hourIdList = this.hourId
      // data.contactUserIdList = this.checkedId
      data.venueId = this.id
      this.hourId.forEach((item) => {
        if (item) {
          data.hourIdList.push(item)
        }
      })
      this.checkedId.forEach((item) => {
        if (item) {
          data.contactUserIdList.push(item)
        }
      })

      console.log('data======>', data)
      if (!data.dateId) {
        this.$cue.toast('请选择预约时间')
        return
      }
      if (data.hourIdList.length == 0) {
        this.$cue.toast('请选择时间段')
        return
      }
      if (data.contactUserIdList.length == 0) {
        this.$cue.toast('请选择预约人')
        return
      }
      if (!this.checked && this.rules.knowContent) {
        this.dialogShow = true
        return
      }
      saveVenueReservation(data).then((res) => {
        if (res.code !== 2000) {
          console.log('失败了', res.message)
          this.orderResultShow = true
          this.orderErrorMsg = res.message
          return
        }
        if (res.code == 2000) {
          this.$router.push({
            path: '/reservation/tips',
            query: {
              id: res.result.reservationOrderId,
              venueName: this.detailInfo.venueName,
              address: this.detailInfo.address,
              distance: this.detailInfo.distance,
            },
          })
        }
      })
    },
    dialogConfirm() {
      this.dialogShow = false
      this.checked = true
    },
    dialogCancel() {
      this.dialogShow = false
      this.checked = false
    },
    onConfirm(value) {
      console.log('value=====>', value)
      this.value1 = value.name
      this.form.type = value.type
      this.showPicker = false
    },
    back() {
      this.$router.go(-1)
    },
    selectDate(item) {
      if (item.isReservationFull == true) {
        return false
      }
      this.selectId = item.id

      this.hourId = []
      this.getHour()
    },
    selectHour(item, index) {
      // 只能选一个时间段,多选的话注释这段
      let hourIdList = []
      this.hourId.forEach((item) => {
        if (item) {
          hourIdList.push(item)
        }
      })
      console.log('hourIdList===============>', hourIdList)
      if (hourIdList.length == 1 && this.hourId[index]) {
        this.hourId[index] = undefined
      } else {
        this.hourId = []
        this.hourId[index] = item.id
      }
      console.log(this.hourId)
      console.log('hourId===============>', this.hourId)
      this.$forceUpdate()

      //----------------------------

      // 多选时间段
      // if (this.hourId[index]) {
      //   this.hourId[index] = undefined
      // } else {
      //   this.hourId[index] = item.id
      // }
      // console.log(this.hourId.length)
      // this.$forceUpdate()
    },
    getDate() {
      // 类型（1-可预约天数，2-日历）
      getReservationDate({ venueId: this.id, type: 1 }).then((res) => {
        console.log('res=======>' + JSON.stringify(res))
        this.dateList = res.result
        this.maxDate = new Date(this.dateList[this.dateList.length - 1].rdate)
        this.showDateList = []
        if (res.result && res.result.length > 0) {
          res.result.forEach((item) => {
            if (item.status != 4 && item.isCloseLib != true) {
              this.showDateList.push(item)
            }
          })
        }
        console.log('showDateList=======>', this.showDateList)

        // console.log("res=======>" + JSON.stringify(this.dateList))
        // this.empty = this.dateList.every((item) => {
        //   item.isReservationFull
        // })
        // 默认选中可预约的时间
        let latelyTime = this.showDateList.find((item) => {
          return item.isReservationFull == false
        })
        console.log('latelyTime=====>', latelyTime)
        // 判断是否所有日期都已约满
        if (!latelyTime.id) {
          this.empty = true
        } else {
          this.selectId = latelyTime.id
          this.getHour()
        }
        console.log('empty======>', this.empty)
      })
    },
    getHour() {
      getReservationHour({ venueId: this.id, dateId: this.selectId }).then((res) => {
        console.log(res)
        this.hourList = res.result
        // 默认选中可预约的时间
        let latelyTime = this.hourList.find((item) => {
          return item.isReservationFull == false
        })
        console.log('latelyTime=====>', latelyTime)

        if (latelyTime.id) {
          this.hourList.forEach((item, index) => {
            if (item.id == latelyTime.id) {
              this.hourId[index] = latelyTime.id
            }
          })
        }
      })
      console.log('hourId===============>', this.hourId)
    },
    goRule() {
      this.$router.push({
        path: '/reservation/rule',
        query: {
          id: this.id,
          type: 0,
        },
      })
    },
    // 获取预约须知
    getRule() {
      getKnowContent({ venueId: this.id }).then((res) => {
        this.rules = res.result
      })
    },
    // 获取证件类型
    // getdict() {
    //   getDictByCode('CREDENTIALS_TYPE').then((res) => {
    //     this.columns = res.result
    //   })
    // },
    handleDecryptCard(value) {
      return decrypt(value).replace(/(\w{5})\w*(\w{4})/, '$1********$2')
    },
    handleDecryptPhone(value) {
      return decrypt(value).replace(/(\w{3})\w*(\w{4})/, '$1****$2')
    },
    handledateName(value) {
      let index = new Date(value).getDay()
      let week = this.weekArrayList[index]
      return week
    },
    getContacts() {
      getUserList().then((res) => {
        console.log(res)
        this.contactList = res.result
        this.form = {}
        this.checkedId = []
        this.value = ''
      })
    },
    selectContact(item, index) {
      if (this.checkedId[index]) {
        this.checkedId[index] = undefined
      } else {
        if (this.selectPeopleId.length >= this.rules.maxPerson) {
          this.$cue.toast('单次限制报名人数为' + this.rules.maxPerson)
          return
        }
        this.checkedId[index] = item.id
      }
      this.selectPeopleId = []
      this.checkedId.forEach((item) => {
        if (item) {
          this.selectPeopleId.push(item)
        }
      })
      console.log(this.selectPeopleId)
      this.$forceUpdate()
    },
    onSubmit() {
      this.$refs.form
        .validate()
        .then(() => {
          //  验证通过
          console.log(this.form)
          if (!this.form.type) {
            this.form.type = 0
          }
          const params = { ...this.form, cardNumber: encrypt(this.form.cardNumber), phone: encrypt(this.form.phone) }
          console.log('加密后的数据====>', params)
          if (this.form.id) {
            this.edit(params)
          } else {
            this.add(params)
          }
        })
        .catch(() => {})
    },
    add(data) {
      saveUser(data).then((res) => {
        if (res.code == 2000) {
          this.showPicker = this.addShow = false
          this.getContacts()
        }
      })
    },
    edit(data) {
      updateUser(data).then((res) => {
        if (res.code == 2000) {
          this.showPicker = this.addShow = false
          this.getContacts()
        }
      })
    },
    addUser() {
      if (this.contactList.length >= 10) {
        this.$cue.toast('至多添加10位人员')
        return
      }
      this.form = {}
      this.addShow = true
    },
    editContact(item) {
      this.addShow = true
      // this.form = { ...item }
      this.form = { ...item, cardNumber: decrypt(item.cardNumber), phone: decrypt(item.phone) }

      this.columns.forEach((ele) => {
        if (ele.type == item.type) {
          this.value = ele.name
        }
      })
    },
    delContact(item) {
      removeUser({ id: item.id }).then((res) => {
        if (res.code == 2000) {
          this.getContacts()
        }
      })
    },
    specialFocus(focus) {
      this.bottomMarginWhenFocus = '75%'
    },
    specialBlur() {
      this.bottomMarginWhenFocus = '60%'
    },
    calendarFormatter(dateVal) {
      let year = dateVal.date.getYear()
      let month = dateVal.date.getMonth() + 1
      let date = dateVal.date.getDate()

      let targetDay = this.dateList.find((item) => {
        let rdateVal = new Date(item.rdate)
        return rdateVal.getYear() == year && rdateVal.getMonth() + 1 == month && rdateVal.getDate() == date
      })
      if (targetDay) {
        if (targetDay.isCloseLib) {
          dateVal.bottomInfo = '闭馆'
          dateVal.className = 'calendar-disable'
          dateVal.type = 'disabled'
        } else if (targetDay.isReservationFull) {
          dateVal.bottomInfo = '约满'
          dateVal.className = 'calendar-disable'
          dateVal.type = 'disabled'
        } else if (targetDay.status == 4) {
          dateVal.bottomInfo = '未开放'
          dateVal.className = 'calendar-disable'
          dateVal.type = 'disabled'
        } else if (targetDay.status != 1) {
          dateVal.className = 'calendar-disable'
          dateVal.type = 'disabled'
        } else {
          let todayValue = new Date()
          //周末
          if (
            year * 365 + month * 30 + date >= todayValue.getYear() * 365 + (todayValue.getMonth() + 1) * 30 + todayValue.getDate() &&
            (dateVal.date.getDay() == 6 || dateVal.date.getDay() == 0)
          ) {
            dateVal.className = 'calendar-weekend'
          }
        }
      } else {
        dateVal.type = 'disabled'
      }
      return dateVal
    },
    confirmCalendar(dateVal) {
      if (!dateVal) {
        this.showCalendar = false
        return
      }
      let year = dateVal.getYear()
      let month = dateVal.getMonth() + 1
      let date = dateVal.getDate()

      let targetDay = this.dateList.find((item) => {
        let rdateVal = new Date(item.rdate)
        return rdateVal.getYear() == year && rdateVal.getMonth() + 1 == month && rdateVal.getDate() == date
      })
      if (targetDay) {
        this.selectDate(targetDay)
      }
      this.showCalendar = false
    },
    clickDay(clickdate) {
      let year = clickdate.getYear()
      let month = clickdate.getMonth() + 1
      let date = clickdate.getDate()

      let targetDay = this.dateList.find((item) => {
        let rdateVal = new Date(item.rdate)
        return rdateVal.getYear() == year && rdateVal.getMonth() + 1 == month && rdateVal.getDate() == date
      })
      console.log('test1')
      if (targetDay) {
        console.log('test2')
        if (targetDay.isCloseLib || targetDay.isReservationFull || targetDay.status != 1) {
          console.log('test3')
          this.$cue.toast('当前日期不可预约，请重新选择')
        }
      } else {
        console.log('test4')
        this.$cue.toast('当前日期不可预约，请重新选择')
      }
    },
  },
  mounted() {
    const { id, type, venueName, siteName, address, distance, latitude, longitude } = this.$route.query
    this.id = id
    this.type = type
    this.detailInfo = { ...this.detailInfo, venueName, siteName, address, distance, latitude, longitude }
    this.getDate()
    // this.getdict()
    this.getContacts()
    this.getRule()
  },
}
</script>
<style lang="scss">
.apply_container {
  width: 100%;
  height: 100vh;
  background: #fff;

  .authentication_box {
    padding: 1.6rem 1.15rem 1.2rem 1.2rem;
    width: 16.35rem;
    // height: 17.8rem;
    background: #ffffff;
    border-radius: 0.4rem;
    .img_name {
      width: 4.4rem;
      height: 4.4rem;
      margin-bottom: 0.6rem;
    }
    .box_title {
      font-size: 1rem;
      font-weight: 600;
      color: #000000;
      line-height: 1.4rem;
    }
    .sub_title {
      font-size: 0.7rem;
      color: #666666;
      line-height: 1rem;
      text-align: center;
      margin: 0.8rem 0 1.2rem 0;
    }
    .box_btn {
      width: 13.95rem;
      height: 2rem;
      line-height: 2rem;
      text-align: center;
      border-radius: 1.1rem;
      font-size: 0.8rem;
      color: #a97048;
      border: 1px solid #a97048;

      &.name_btn {
        color: #ffffff;
        background: #a97048;
        margin-bottom: 0.6rem;
      }
    }
  }

  .select_icon {
    width: 0.7rem;
    height: 0.7rem;
    margin-bottom: 2px;
  }
  .content_dialog {
    padding: 1.6rem;
    font-size: 0.7rem;
    color: #212121;
    line-height: 1rem;
    text-align: center;
    .rules {
      font-weight: 600;
      color: #a97048;
    }
  }
  .result_content {
    font-size: 0.6rem;
    color: #666666;
    line-height: 0.8rem;
    padding: 2rem 0;
    .result_img {
      width: 9rem;
      height: 9rem;
    }
    .title {
      margin-bottom: 0.35rem;
      font-size: 0.7rem;
      font-weight: 600;
      color: #212121;
      line-height: 1rem;
    }
  }
  .emtpy {
    padding: 2.5rem 0;
    font-size: 0.6rem;
    color: #666666;
    line-height: 0.8rem;
    .empty_img {
      width: 9rem;
      height: 9rem;
    }
  }

  .popup {
    padding: 0.8rem 0.6rem 0 0.6rem;
    .van-field__control,
    .van-field__error-message {
      text-align: right !important;
    }
    .form {
      margin-top: 0.5rem;
    }
    .title {
      width: 100%;
      text-align: center;
      font-size: 0.8rem;
      font-weight: 600;
      color: #000000;
    }
    .close_icon {
      position: absolute;
      top: 1.05rem;
      right: 0.9rem;
      width: 0.7rem;
      height: 0.7rem;
    }
  }

  .navbar {
    z-index: 10;
    width: 100%;
    height: 44px;
    position: fixed;
    top: 40px;
    // top: calc(40px + env(safe-area-inset-top));
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    background: #fff;
    .back {
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .apply_content {
    padding: 0 0.6rem;
    width: 100%;
    box-sizing: border-box;
    // height: calc(100% - 44px - env(safe-area-inset-top));
    height: calc(100% - 84px);

    position: absolute;
    // top: calc(44px + env(safe-area-inset-top));
    top: 84px;
    left: 0;
    overflow-y: auto;
    padding-bottom: calc(3rem + env(safe-area-inset-bottom));
  }
}
.apply_content {
  .header {
    margin: 0.8rem 0 0;
    border-bottom: 0.05rem solid #f4f4f4;
    padding-bottom: 0.9rem;

    .name {
      font-size: 0.9rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .address {
      font-size: 0.6rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      display: flex;
      justify-content: start;
      align-items: center;
      margin-bottom: 0.7rem;
      .address-icon {
        width: 0.7rem;
        height: 0.7rem;
      }
      .address-text {
        padding-left: 0.2rem;
        max-width: 13.5rem;
        display: flex;
        .detail {
          width: auto;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .shuline {
          padding: 0 0.2rem;
        }
      }
      .arrow-icon {
        width: 1.2rem;
        height: 1.2rem;
        margin-left: 0.8rem;
      }
    }
    .buildName {
      font-size: 0.6rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #212121;
      line-height: 0.8rem;
      // padding-bottom: 0.9rem;
      // margin-bottom: 0.7rem;
    }
  }
}
.section {
  .header {
    display: flex;
    justify-content: space-between;
    // justify-content: row;
    align-items: center;
    .title {
      font-size: 0.8rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #212121;

      line-height: 1.2rem;
      .star {
        color: #e63633;
      }
      .select_pepple {
        margin-left: 0.4rem;
        font-size: 0.7rem;
        color: #666666;
        line-height: 1rem;
        font-weight: 400;
      }
    }
    .more {
      margin-left: auto;
      display: flex;
      flex-direction: row;
      .more-text {
        font-size: 0.5rem;
        margin-left: 0.2rem;
        color: #a97048;
      }
      .riliIcon {
        width: 0.7rem;
        height: 0.7rem;
      }
    }
    .addbtn {
      // width: 3.5rem;
      height: 1.4rem;
      border-radius: 0.7rem;
      border: 0.05rem solid #a97048;
      text-align: center;
      line-height: 1.3rem;
      font-size: 0.6rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a97048;
      padding: 0 0.8rem;
      .add-icon {
        width: 0.5rem;
        height: 0.5rem;
        margin-right: 0.2rem;
        vertical-align: middle;
      }
    }
    .disable {
      border: 0.05rem solid #f7f7f7;
      color: #999999;
      .add-icon {
        opacity: 0.2;
      }
    }
  }
  .reservation-choose-day-box {
    // margin-top: 0.8rem;
    margin-left: -0.6rem;
    overflow-x: scroll;
    .reservation-choose-day-list {
      display: flex;
      flex-wrap: nowrap;
      justify-content: start;

      .day-item {
        flex-shrink: 0;
        position: relative;
        width: 3.8rem;
        height: 2.7rem;
        margin-left: 0.6rem;
        background-color: rgba(248, 232, 213, 1);
        // background-color: #f7f7f7;
        border: 0.05rem dashed #ccc;
        .tag {
          border-right: 0.05rem dashed #ccc;
          border-left: 0.05rem dashed #ccc;
          border-bottom: 0.05rem dashed #ccc;
          position: absolute;
          right: 0;
          top: 0;
          width: 1.4rem;
          height: 0.8rem;
          text-align: center;
          line-height: 0.7rem;
          font-size: 0.5rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .name {
          margin: 0.3rem 0 0.1rem;
        }
        .name,
        .subname {
          font-size: 0.7rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #212121;
          line-height: 1rem;
          margin-left: 0.4rem;
        }
        &.selected {
          position: relative;
          background-color: rgba(248, 232, 213, 1);
          // border: 0.05rem solid #47988a;
          border: 0.05rem solid #a97048;
          border-radius: 0.4rem;

          .selected-icon {
            width: 0.8rem;
            height: 0.8rem;
            position: absolute;
            right: 0;
            top: 0;
          }
          .name,
          .subname {
            color: #a97048;
          }
        }
        &.normal {
          // background-color: rgb(232, 245, 244);
          background-color: rgba(248, 232, 213, 1);
          // border: 0.05rem dashed #ccc;
          .name,
          .subname {
            color: #666666;
          }
        }
        &.is_fill {
          background-color: #f7f7f7;
        }
      }
    }
  }
  .reservation-choose-time {
    margin-top: 0.8rem;
    background-color: rgba(248, 232, 213, 1);

    border: 0.05rem dashed #ccc;
    width: 100%;
    height: 2.7rem;
    box-sizing: border-box;
    padding: 0 0.4rem;
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #212121;
    width: calc(50% - 0.33rem);
    .num {
      color: #a97048;
    }
    .arrow-icon {
      width: 0.6rem;
      height: 0.35rem;
    }
    &.selected {
      position: relative;
      background-color: rgba(248, 232, 213, 1);
      // border: 0.05rem solid #47988a;
      border: 0.05rem solid #a97048;
      border-radius: 0.4rem;
      color: #a97048;

      .selected-icon {
        width: 0.8rem;
        height: 0.8rem;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    &.is_fill {
      background-color: #f7f7f7;
      color: #9999;
    }
  }
}
.selected-content {
  padding-top: 0.4rem;

  .people {
    width: 100%;
    // height: 78px;
    background: #f7f7f7ff;
    border: 1px dotted rgb(224, 224, 224);
    margin-bottom: 0.6rem;
    padding: 0.5rem 0.6rem;
    .select {
      margin: 0 0.6rem 0 0;
    }
    .no_select {
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 0.1rem;
      border: 1px solid #999999;
      margin: 0 0.6rem 0 0;
    }

    .icon_right {
      font-size: 0.5rem;
      color: #666666;
      line-height: 0.6rem;
      .icon_item {
        margin-right: 0.6rem;
      }
    }
    .name {
      font-size: 0.7rem;
      font-weight: 600;
      color: #212121;
      line-height: 1rem;
      margin-bottom: 0.2rem;
      .tag {
        margin-left: 4px;
        padding: 0 2px;
        height: 0.6rem;
        font-size: 9px;
        color: #666666;
        line-height: 0.6rem;
        border-radius: 2px;
        border: 1px solid #666666;
        text-align: center;
      }
    }
    .phone,
    .identity_card {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .phone {
      margin-bottom: 2px;
    }
  }

  .selected-num {
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 1rem;
  }
  .person-list {
    padding-top: 0.8rem;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    .person-item {
      display: inline-block;
      padding: 0.2rem 0.5rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin: 0 0.6rem 0.6rem 0;
      background-color: #f7f7f7;
      border: 0.05rem dashed #ccc;
      &.active {
        color: #fff;
        background-color: #47988a;
        border: 0.05rem solid #47988a;
        border-radius: 0.2rem;
      }
    }
  }
  // .person-card {
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   padding: 0.5rem 0.6rem;
  //   .left {
  //     .name {
  //       font-size: 0.7rem;
  //       font-family: PingFangSC-Medium, PingFang SC;
  //       font-weight: 500;
  //       color: #212121;
  //     }
  //     .phone {
  //       font-size: 0.6rem;
  //       font-family: PingFangSC-Regular, PingFang SC;
  //       font-weight: 400;
  //       color: #666666;
  //     }
  //     .sfid {
  //       font-size: 0.6rem;
  //       font-family: PingFangSC-Regular, PingFang SC;
  //       font-weight: 400;
  //       color: #666666;
  //     }
  //   }
  //   .btns {
  //     display: flex;
  //     justify-content: end;
  //     font-size: 0.5rem;
  //     font-family: PingFangSC-Regular, PingFang SC;
  //     font-weight: 400;
  //     color: #666666;

  //     .btn {
  //       text-align: center;
  //       margin-left: 0.7rem;
  //       .icon-btn {
  //         width: 0.7rem;
  //         height: 0.7rem;
  //       }
  //     }
  //   }
  // }
}
.dashed-box {
  // margin-top: 0.8rem;
  background-color: #f7f7f7;
  border: 0.05rem dashed #ccc;
}
.tips {
  margin-top: 1rem;
  font-size: 0.7rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 1rem;
  .yuanChoose {
    display: inline-block;
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 0.3rem;
    border: 0.05rem solid #47988a;
    margin-right: 0.4rem;
  }
  .rule {
    margin-left: 0.4rem;
  }
  .green {
    // color: #47988a;
    color: #a97048;
  }
}
.confirm {
  width: 85%;
  height: 2rem;
  background: #a97048;
  border-radius: 1.1rem;
  margin: 1rem auto;
  text-align: center;
  font-size: 0.8rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 2rem;
}
.calendar {
  width: 100%;
  height: 30vh;
}
.calendar-weekend {
  color: #a97048;
}
.calendar-disable {
  color: #9999;
}
</style>
